import { useState, createContext } from 'react';

const INITIAL_VALUES = {
  isLoading: false,
  setIsLoading: (v) => {},
  modalOpened: false,
  setModalOpened: (v) => {},
  fetchCount: 0,
  setFetchCount: (v) => {},
  allFetchedInstallments: null,
  setAllFetchedInstallments: (v) => {},
  selectedInstallment: null,
  setSelectedIntallment: (v) => {},
  nameSearchValue: '',
  setNameSearchValue: (v) => {},
  isSubmittingForm: false,
  setIsSubmittingForm: (v) => {}
};

const InstallmentsPageContext = createContext(INITIAL_VALUES);

export const InstallmentsPageProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(INITIAL_VALUES.isLoading);
  const [modalOpened, setModalOpened] = useState(INITIAL_VALUES.modalOpened);
  const [fetchCount, setFetchCount] = useState(INITIAL_VALUES.fetchCount);
  const [allFetchedInstallments, setAllFetchedInstallments] = useState(
    INITIAL_VALUES.allFetchedInstallments
  );
  const [selectedInstallment, setSelectedIntallment] = useState(
    INITIAL_VALUES.selectedInstallment
  );
  const [nameSearchValue, setNameSearchValue] = useState(
    INITIAL_VALUES.nameSearchValue
  );
  const [isSubmittingForm, setIsSubmittingForm] = useState(
    INITIAL_VALUES.isSubmittingForm
  );

  return (
    <InstallmentsPageContext.Provider
      value={{
        isLoading,
        setIsLoading,
        modalOpened,
        setModalOpened,
        fetchCount,
        setFetchCount,
        allFetchedInstallments,
        setAllFetchedInstallments,
        selectedInstallment,
        setSelectedIntallment,
        nameSearchValue,
        setNameSearchValue,
        isSubmittingForm,
        setIsSubmittingForm
      }}
    >
      {children}
    </InstallmentsPageContext.Provider>
  );
};

export default InstallmentsPageContext;
